import React from 'react';

export default function Founder() {
  const expertise = [
    'Healthcare AI & SaMD Platforms (FDA/HIPAA/GDPR-aligned)',
    'Radiology AI, Pathology AI, and Medical Imaging Systems',
    'Acoustic AI, Signal Processing, and TinyML Edge Deployment',
    'Multi-Omics, Bioinformatics, and Translational AI',
    'Enterprise & Cloud Architecture (AWS, Azure, TOGAF 9.2)'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-tealLight/30 to-paper text-ink antialiased selection:bg-teal/20 selection:text-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 font-sans">
        <div className="text-center mb-12">
          <div className="inline-block mb-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-tealLight border border-teal/20 text-teal text-xs font-semibold uppercase tracking-wider">
              Leadership
            </div>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-sans font-bold leading-tight tracking-tight text-center text-teal">
            Our Founder
          </h1>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1 group relative bg-white border border-rule rounded-xl p-8 shadow-[4px_4px_0_0_rgba(20,184,166,0.18)] hover:shadow-[6px_6px_0_0_rgba(20,184,166,0.3)] hover:-translate-y-0.5 hover:-translate-x-0.5 transition-all duration-200 text-center">
            <div className="w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden border-4 border-teal shadow-lg bg-gray-100">
              <img
                src="/profile.jpg"
                alt="Ram Samudrala - Founder"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <h3 className="text-2xl font-bold text-ink group-hover:text-teal transition-colors">Ram Samudrala</h3>
            <p className="text-xs font-semibold text-teal uppercase tracking-widest mt-1">Founder, CEO & Chief Architect</p>
            <div className="mt-5 space-y-2 text-left">
              <p className="text-sm text-inkSoft">• 23+ years enterprise-scale system design</p>
              <p className="text-sm text-inkSoft">• Distinguished Architect & Polyglot Technologist</p>
              <p className="text-sm text-inkSoft">• FDA/HIPAA/GDPR-aligned SaMD Platforms</p>
              <p className="text-sm text-inkSoft">• Azure + AWS Certified · TOGAF 9.2</p>
            </div>
          </div>

          <div className="lg:col-span-2 space-y-6">
            <div className="group relative bg-white border border-rule rounded-xl p-6 shadow-[4px_4px_0_0_rgba(20,184,166,0.18)] hover:shadow-[6px_6px_0_0_rgba(20,184,166,0.3)] hover:-translate-y-0.5 hover:-translate-x-0.5 transition-all duration-200">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-lg bg-tealLight border border-teal/20 flex items-center justify-center text-lg">👤</span>
                  <h4 className="text-lg font-bold text-ink group-hover:text-teal transition-colors">About the Founder</h4>
                </div>
                <span className="inline-flex items-center gap-1.5 bg-tealLight text-teal text-[10px] font-bold tracking-wider uppercase px-3 py-1.5 rounded-md border border-teal/20">
                  <span className="w-1.5 h-1.5 rounded-full bg-teal"></span>
                  Biography
                </span>
              </div>
              <p className="text-inkSoft text-sm leading-relaxed">
                Ram Samudrala is a Distinguished Architect with over 23 years of experience designing and delivering enterprise-scale software systems
                across AI, Biotechnology, Medical Devices, Healthcare AI, and Cloud Platforms.
              </p>
              <p className="text-inkSoft text-sm leading-relaxed mt-3">
                Experience spans Artificial Intelligence, Scientific Computing, Biotechnology, Multi-Omics, Medical Devices,
                Embedded Systems, Healthcare AI, Signal Processing, and Computer Vision — transforming deep scientific concepts
                into scalable, production-ready systems aligned with FDA, HIPAA, and GDPR regulatory standards.
              </p>
            </div>

            <div className="group relative bg-white border border-rule rounded-xl p-6 shadow-[4px_4px_0_0_rgba(20,184,166,0.18)] hover:shadow-[6px_6px_0_0_rgba(20,184,166,0.3)] hover:-translate-y-0.5 hover:-translate-x-0.5 transition-all duration-200">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-lg bg-tealLight border border-teal/20 flex items-center justify-center text-lg">💡</span>
                  <h4 className="text-lg font-bold text-ink group-hover:text-teal transition-colors">Core Expertise</h4>
                </div>
                <span className="inline-flex items-center gap-1.5 bg-tealLight text-teal text-[10px] font-bold tracking-wider uppercase px-3 py-1.5 rounded-md border border-teal/20">
                  <span className="w-1.5 h-1.5 rounded-full bg-teal"></span>
                  Skills
                </span>
              </div>
              <div className="grid md:grid-cols-2 gap-2">
                {expertise.map((exp, index) => (
                  <div key={index} className="flex items-center gap-2 text-sm text-inkSoft">
                    <span className="text-teal">▹</span> {exp}
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-tealLight p-4 rounded-lg border-l-4 border-teal shadow-[4px_4px_0_0_rgba(20,184,166,0.18)]">
              <p className="text-sm text-inkSoft">
                <strong className="text-teal">IP & Publications:</strong> Granted patent demonstrating original technical contribution.
                Upcoming textbook publication and U.S. patent filings across the Diagnostic Intelligence platform.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
